import React, { useState } from "react";
import { Box, TextInput, Button } from "grommet";
import { View, Hide } from "grommet-icons";
import PropTypes from "prop-types";

export default function PasswordInput({
  id,
  placeholder,
  onChange,
  value,
  ...rest
}) {
  const [showPassword, setShowPassword] = useState(false);

  return (
    <Box direction="row" align="center">
      <TextInput
        id={id}
        placeholder={placeholder}
        type={showPassword ? "text" : "password"}
        onChange={onChange}
        value={value}
        {...rest}
      />
      <Button
        icon={
          showPassword ? (
            <View style={{ width: 15, marginLeft: 5 }} />
          ) : (
            <Hide />
          )
        }
        onClick={() => setShowPassword(!showPassword)}
        plain
        style={{ marginLeft: "-40px", zIndex: 1 }}
      />
    </Box>
  );
}

PasswordInput.propTypes = {
  id: PropTypes.string,
  placeholder: PropTypes.string,
  onChange: PropTypes.func,
  value: PropTypes.string,
};

PasswordInput.defaultProps = {
  id: "password",
  placeholder: "Enter your password",
};
